import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Btn, Field, Logo, Spinner } from "@/components/rp";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { loginWith } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [bad, setBad] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/password-token", { params: { token } }).then((r) => setInfo(r.data)).catch((e) => setBad(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (pw !== pw2) return setError("Le due password non coincidono");
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password: pw });
      loginWith(data);
      navigate(data.user.role === "admin" ? "/admin" : "/commessa", { replace: true });
    } catch (err) {
      setError(errMsg(err));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-[420px] rp-fade" data-testid="set-password-page">
        <Logo className="h-9 mb-10" />
        {!info && !bad && <Spinner />}
        {bad && (
          <div data-testid="set-password-invalid">
            <h1 className="text-3xl font-semibold tracking-tight">Link non valido</h1>
            <p className="text-[#757575] mt-3">{bad}</p>
            <Link to="/login" className="rp-btn bg-black text-white h-12 mt-8 w-full" data-testid="set-password-go-login">Vai all'accesso</Link>
          </div>
        )}
        {info && (
          <>
            <p className="rp-label mb-3">{info.kind === "invite" ? "Attiva il tuo accesso" : "Nuova password"}</p>
            <h1 className="text-4xl font-semibold tracking-tight">{info.kind === "invite" ? `Benvenuto, ${info.name.split(" ")[0]}` : "Scegli una nuova password"}</h1>
            <p className="text-[#757575] mt-3">Accederai con <b className="text-black" data-testid="set-password-email">{info.email}</b> e la password che scegli qui.</p>
            <form onSubmit={submit} className="mt-8 space-y-5" data-testid="set-password-form">
              <Field label="Password" hint="Almeno 8 caratteri"><input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="rp-field" autoComplete="new-password" data-testid="set-password-input" /></Field>
              <Field label="Ripeti la password"><input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="rp-field" autoComplete="new-password" data-testid="set-password-confirm" /></Field>
              {error && <p className="text-sm text-[#DC3545]" data-testid="set-password-error">{error}</p>}
              <Btn type="submit" loading={loading} className="w-full h-12" data-testid="set-password-submit">Salva ed entra</Btn>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
